import { Injectable } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { UiLoadingModalComponent } from './loading-modal';

export interface UiLoadingModalOptions {
  title?: string;
  description?: string;
}

@Injectable({ providedIn: 'root' })
export class UiLoadingModalService {
  private modalRef?: NzModalRef<UiLoadingModalComponent>;

  constructor(private readonly modal: NzModalService) {}

  open(options?: UiLoadingModalOptions): void {
    if (this.modalRef) return;

    this.modalRef = this.modal.create<UiLoadingModalComponent>({
      nzContent: UiLoadingModalComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzKeyboard: false,
      nzCentered: true,
      nzFooter: null,
      nzWidth: 440,
      nzBodyStyle: { padding: '20px 24px' },
    });

    if (this.modalRef.componentInstance) {
      this.modalRef.componentInstance.title = options?.title;
      this.modalRef.componentInstance.description = options?.description;
    }
  }

  close(): void {
    if (!this.modalRef) return;
    this.modalRef.destroy();
    this.modalRef = undefined;
  }
}
